import { useState } from "react";

const testimonials = [
  {
    name: "Marcus Thompson",
    role: "Verified Buyer, NYC",
    quote: "I have been using superbuy spreadsheets for over a year now and they have completely changed how I shop online. The curated finds save me so much time, and I have discovered brands I would never have found on my own. The QC photos give me confidence before every purchase.",
    rating: 5,
  },
  {
    name: "Emma Richardson",
    role: "Fashion Blogger, London",
    quote: "As someone who writes about streetwear and fashion daily, having access to a well-organized superbuy spreadsheet is a game-changer. The comparison tables help me find the best prices, and the seller ratings mean I never worry about getting scammed.",
    rating: 5,
  },
  {
    name: "David Chen",
    role: "Sneaker Collector, LA",
    quote: "The superbuy spreadsheet community is incredible. I have built my entire sneaker collection using these curated lists. The shipping guides alone have saved me hundreds of dollars. Cannot recommend this enough for anyone serious about buying from overseas.",
    rating: 5,
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-12">
        <div className="text-center mb-10">
          <p className="text-sm font-medium text-secondary-600 mb-2">( Trusted by 10,000+ Buyers )</p>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center">
              <span className="text-background-50 font-bold text-lg">{t.name.charAt(0)}</span>
            </div>
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span>4.9 / 5.0</span>
              </div>
            </div>
          </div>

          <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-heading italic mb-6">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
              <span className="text-secondary-700 font-semibold text-sm">{t.name.charAt(0)}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.role}</p>
            </div>
          </div>

          <div className="flex gap-2 absolute bottom-0 right-0">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}